module.exports = __webpack_public_path__ + "static/media/mt.cb2ef9e1.svg";